var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.configIsLoaded)?_c('v-main',{staticStyle:{"background-color":"#f1f1f1"}},[_c('router-view')],1):_vm._e(),_c('gk-progress',{attrs:{"tag":"api"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }